import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function MSOPricingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [providers, setProviders] = useState(3);
  const [includeRCM, setIncludeRCM] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const monthlyCollections = 75000 * providers;
  const monthlyManagementFee = 250 * providers;
  const opsShare = monthlyCollections * 0.025;
  const rcmShare = includeRCM ? monthlyCollections * 0.025 : 0;
  const totalMonthlyFee = monthlyManagementFee + opsShare + rcmShare;
  const totalRevShare = includeRCM ? 5.0 : 2.5;

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-gradient-to-b from-[#0A1628] to-[#1B4B7F]'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/6f24c25eed393f63407e0e21645fee7d.png"
                alt="MedxMSO Logo"
                className="h-12 w-auto"
              />
              <span className={`text-xl font-black tracking-tight whitespace-nowrap ${scrolled ? 'text-[#1B4B7F]' : 'text-white'}`}>MedxMSO</span>
            </Link>
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Home</Link>
              <Link to="/services" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Services</Link>
              <Link to="/pricing" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Models</Link>
              <Link to="/mso-pricing" className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#1B4B7F]' : 'text-white'}`}>Vendor Pricing</Link>
              <Link to="/partnership" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#059669] hover:text-[#047857]' : 'text-[#6EE7B7] hover:text-white'}`}>Partnership</Link>
              <Link to="/why-mso" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-[#1B4B7F]' : 'text-white hover:text-gray-200'}`}>Why MSO?</Link>
              <Link to="/audit" className={`text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#BE185D] hover:text-[#9D174D]' : 'text-[#F9A8D4] hover:text-white'}`}>Request Audit</Link>
              <Link to="/#contact" className={`px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'bg-[#1B4B7F] text-white hover:bg-[#153a63]' : 'bg-white/20 border border-white/40 text-white hover:bg-white/30'}`}>
                Get Started
              </Link>
            </div>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="px-6 py-4 space-y-3">
              <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Home</Link>
              <Link to="/services" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Services</Link>
              <Link to="/pricing" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Models</Link>
              <Link to="/mso-pricing" className="block text-sm font-semibold text-[#1B4B7F] cursor-pointer">Vendor Pricing</Link>
              <Link to="/partnership" className="block text-sm font-semibold text-[#059669] cursor-pointer">Partnership</Link>
              <Link to="/why-mso" className="block text-sm font-medium text-gray-700 hover:text-[#1B4B7F] cursor-pointer">Why MSO?</Link>
              <Link to="/audit" className="block text-sm font-semibold text-[#BE185D] cursor-pointer">Request Audit</Link>
              <Link to="/#contact" className="block bg-[#1B4B7F] text-white px-6 py-2.5 rounded-full text-sm font-medium text-center cursor-pointer">Get Started</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-[#F0F7FF] to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-[#1B4B7F]/10 text-[#1B4B7F] px-5 py-2 rounded-full text-xs font-bold tracking-widest mb-6">
              <i className="ri-briefcase-line"></i>
              MSO VENDOR MODEL — PRICING
            </div>
            <h1 className="text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-8">
              Transparent MSO<br />Vendor Pricing
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-6">
              Trade fixed overhead for scalable, performance-based costs. Our transparent fee structure aligns our success with yours — no hidden fees, just value-based support.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="inline-flex items-center gap-2 bg-white px-6 py-2.5 rounded-full text-sm font-medium shadow-sm">
                <i className="ri-shield-check-line text-[#0D9488] text-xl"></i>
                <span className="text-sm font-semibold text-gray-700">Clinical decisions remain 100% with providers</span>
              </div>
              <Link to="/partnership" className="inline-flex items-center gap-2 bg-[#059669]/10 text-[#059669] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#059669]/20 transition-colors cursor-pointer">
                <i className="ri-vip-crown-line"></i>
                Explore Partnership Model instead
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why This Structure */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-8">
                Why This<br />
                Fee Structure?
              </h2>
              <div className="space-y-6 text-gray-600 leading-relaxed text-lg">
                <p>
                  Traditional MSO models lock you into high fixed costs regardless of performance. Our hybrid approach combines a low monthly base fee with performance-based revenue sharing — meaning we only succeed when you succeed.
                </p>
                <p>
                  This structure allows physicians to access enterprise-level infrastructure, compliance support, and operational expertise without the burden of massive upfront investments or inflexible contracts.
                </p>
              </div>
              <div className="mt-10 space-y-4">
                {[
                  { icon: 'ri-line-chart-line', title: 'Aligned Incentives', desc: 'Our revenue share model means we\'re invested in your practice growth and operational efficiency.' },
                  { icon: 'ri-scales-line', title: 'Scalable Costs', desc: 'Pay based on your practice size and performance — costs scale naturally with your growth.' },
                  { icon: 'ri-shield-check-line', title: 'Complete Transparency', desc: 'No hidden fees, no surprise charges — just straightforward pricing you can understand and predict.' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#F0F7FF] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-[#1B4B7F] text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">{item.title}</h4>
                      <p className="text-gray-600 text-sm">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="bg-gradient-to-br from-[#1B4B7F] to-[#0D9488] rounded-3xl p-12 text-white">
                <h3 className="text-3xl font-bold mb-8">What's Included</h3>
                <div className="space-y-6">
                  {[
                    { title: 'HR & Staffing Support', desc: 'Recruitment, onboarding, payroll, benefits administration' },
                    { title: 'Group Purchasing (GPO) Access', desc: 'Negotiated rates on supplies, equipment, and services' },
                    { title: 'Compliance Oversight', desc: 'HIPAA audits, credentialing, regulatory documentation' },
                    { title: 'IT Infrastructure', desc: 'EHR/EMR support, cybersecurity, technology integration' },
                    { title: 'Financial Reporting', desc: 'Monthly dashboards, budgeting, strategic planning' },
                    { title: 'Practice Optimization', desc: 'Workflow analysis, efficiency consulting, growth strategies' },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4">
                      <i className="ri-check-line text-2xl text-white/80 mt-1 flex-shrink-0"></i>
                      <div>
                        <div className="font-semibold mb-1">{item.title}</div>
                        <div className="text-white/80 text-sm">{item.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fee Structure Breakdown */}
      <section className="py-20 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">Fee Structure Breakdown</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Simple, transparent pricing with no surprises. Choose the level of support that fits your practice needs.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {[
              { icon: 'ri-rocket-line', title: 'Onboarding', price: '$2,500', sub: 'One-time setup fee', items: ['Practice integration', 'HIPAA compliance audits', 'Workflow mapping', 'Technology setup'] },
              { icon: 'ri-user-line', title: 'Management', price: '$250', sub: 'Per provider / month', items: ['Software & infrastructure', 'HR support', 'GPO access', 'Compliance oversight'] },
              { icon: 'ri-line-chart-line', title: 'Ops Share', price: '2.5%', sub: 'Of net collections', items: ['Performance alignment', 'Growth optimization', 'Operational efficiency', 'Strategic consulting'] },
              { icon: 'ri-money-dollar-circle-line', title: 'RCM Add-on', price: '+2.5%', sub: 'Of net collections', items: ['Full-cycle billing', 'Medical coding', 'Denials management', 'Payer negotiations'], highlight: true },
            ].map((card, i) => (
              <div key={i} className={`bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300 ${card.highlight ? 'border-2 border-[#0D9488]' : ''}`}>
                <div className="w-14 h-14 bg-gradient-to-br from-[#1B4B7F] to-[#0D9488] rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${card.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{card.title}</h3>
                <div className="text-4xl font-bold text-[#1B4B7F] mb-4">{card.price}</div>
                <p className="text-sm text-gray-500 mb-6">{card.sub}</p>
                <ul className="space-y-3">
                  {card.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-[#0D9488] mt-0.5 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">Choose Your Service Level</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Compare our Standard Management package with our Full-Service option that includes comprehensive Revenue Cycle Management.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {/* Standard */}
            <div className="bg-white border-2 border-gray-200 rounded-3xl p-10 hover:shadow-xl transition-all duration-300">
              <div className="mb-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-3">Standard Management</h3>
                <p className="text-gray-600">Core MSO services for operational excellence</p>
              </div>
              <div className="mb-8 pb-8 border-b border-gray-200">
                <div className="text-sm text-gray-600 mb-2">Total Revenue Share</div>
                <div className="text-5xl font-bold text-gray-900 mb-2">2.5%</div>
                <div className="text-sm text-gray-500">+ $250/provider/month base fee</div>
              </div>
              <div className="space-y-4 mb-10">
                {[
                  { label: 'One-time Onboarding', sub: '$2,500 setup fee', included: true },
                  { label: 'Monthly Management Fee', sub: '$250 per provider', included: true },
                  { label: 'Operational Revenue Share', sub: '2.5% of net collections', included: true },
                  { label: 'HR & Staffing Support', sub: 'Full recruitment and payroll', included: true },
                  { label: 'Compliance & Credentialing', sub: 'HIPAA audits and oversight', included: true },
                  { label: 'IT Infrastructure', sub: 'EHR/EMR support and security', included: true },
                  { label: 'Financial Reporting', sub: 'Monthly dashboards and analysis', included: true },
                  { label: 'Medical Billing & Coding', sub: 'Not included', included: false },
                  { label: 'Denials Management', sub: 'Not included', included: false },
                  { label: 'Payer Contract Negotiations', sub: 'Not included', included: false },
                ].map((row, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className={`${row.included ? 'ri-check-line text-[#0D9488]' : 'ri-close-line text-gray-300'} text-xl mt-0.5 flex-shrink-0`}></i>
                    <div>
                      <div className={`font-semibold ${row.included ? 'text-gray-900' : 'text-gray-400'}`}>{row.label}</div>
                      <div className={`text-sm ${row.included ? 'text-gray-600' : 'text-gray-400'}`}>{row.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/#contact" className="block w-full bg-gray-100 text-gray-900 text-center px-8 py-4 rounded-full text-sm font-semibold hover:bg-gray-200 transition-all whitespace-nowrap cursor-pointer">
                Request Quote
              </Link>
            </div>

            {/* Full Service */}
            <div className="bg-gradient-to-br from-[#1B4B7F] to-[#0D9488] rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 relative">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#F59E0B] text-white px-6 py-2 rounded-full text-xs font-semibold whitespace-nowrap">
                MOST COMPREHENSIVE
              </div>
              <div className="mb-8">
                <h3 className="text-3xl font-bold text-white mb-3">Full-Service Package</h3>
                <p className="text-blue-100">Complete management + revenue cycle services</p>
              </div>
              <div className="mb-8 pb-8 border-b border-white/20">
                <div className="text-sm text-blue-200 mb-2">Total Revenue Share</div>
                <div className="text-5xl font-bold text-white mb-2">5.0%</div>
                <div className="text-sm text-blue-200">+ $250/provider/month base fee</div>
              </div>
              <div className="space-y-4 mb-10">
                {[
                  { label: 'One-time Onboarding', sub: '$2,500 setup fee' },
                  { label: 'Monthly Management Fee', sub: '$250 per provider' },
                  { label: 'Total Revenue Share', sub: '5% of net collections (2.5% ops + 2.5% RCM)' },
                  { label: 'HR & Staffing Support', sub: 'Full recruitment and payroll' },
                  { label: 'Compliance & Credentialing', sub: 'HIPAA audits and oversight' },
                  { label: 'IT Infrastructure', sub: 'EHR/EMR support and security' },
                  { label: 'Financial Reporting', sub: 'Monthly dashboards and analysis' },
                  { label: 'Medical Billing & Coding', sub: 'Full-cycle billing services' },
                  { label: 'Denials Management', sub: 'Proactive claims optimization' },
                  { label: 'Payer Contract Negotiations', sub: 'Expert rate negotiations' },
                ].map((row, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-check-line text-white/80 text-xl mt-0.5 flex-shrink-0"></i>
                    <div>
                      <div className="font-semibold text-white">{row.label}</div>
                      <div className="text-sm text-blue-200">{row.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/#contact" className="block w-full bg-white text-[#1B4B7F] text-center px-8 py-4 rounded-full text-sm font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer">
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ROI Calculator */}
      <section className="py-20 bg-[#FAF8F5]">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">Calculate Your Investment</h2>
            <p className="text-lg text-gray-600">
              Use our calculator to estimate your monthly MSO fees based on your practice size and service level.
            </p>
          </div>
          <div className="bg-white rounded-3xl p-10 shadow-xl">
            <div className="grid md:grid-cols-2 gap-8 mb-10">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-6">Your Practice Details</h3>
                <div className="mb-6">
                  <label className="block text-sm font-semibold text-gray-900 mb-3">Number of Providers</label>
                  <input
                    type="range" min="1" max="20" value={providers}
                    onChange={(e) => setProviders(Number(e.target.value))}
                    className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#1B4B7F]"
                  />
                  <div className="flex justify-between mt-2">
                    <span className="text-sm text-gray-600">1</span>
                    <span className="text-2xl font-bold text-[#1B4B7F]">{providers}</span>
                    <span className="text-sm text-gray-600">20</span>
                  </div>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-semibold text-gray-900 mb-3">Average Monthly Collections per Provider</label>
                  <div className="text-3xl font-bold text-gray-900">${(75000).toLocaleString()}</div>
                  <p className="text-sm text-gray-500 mt-1">Industry average estimate</p>
                </div>
                <div className="mb-6">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox" checked={includeRCM}
                      onChange={(e) => setIncludeRCM(e.target.checked)}
                      className="w-5 h-5 rounded border-gray-300 text-[#1B4B7F] focus:ring-[#1B4B7F] cursor-pointer"
                    />
                    <span className="text-sm font-semibold text-gray-900">Include Revenue Cycle Management (+2.5%)</span>
                  </label>
                </div>
              </div>
              <div className="bg-gradient-to-br from-[#F0F7FF] to-white rounded-2xl p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-6">Estimated Monthly Investment</h3>
                <div className="space-y-4 mb-6">
                  <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                    <span className="text-sm text-gray-600">Base Management Fee</span>
                    <span className="text-lg font-semibold text-gray-900">${monthlyManagementFee.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                    <span className="text-sm text-gray-600">Operational Share (2.5%)</span>
                    <span className="text-lg font-semibold text-gray-900">${opsShare.toLocaleString()}</span>
                  </div>
                  {includeRCM && (
                    <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                      <span className="text-sm text-gray-600">RCM Share (2.5%)</span>
                      <span className="text-lg font-semibold text-gray-900">${rcmShare.toLocaleString()}</span>
                    </div>
                  )}
                </div>
                <div className="bg-white rounded-xl p-6 mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-semibold text-gray-600">Total Monthly Fee</span>
                    <span className="text-4xl font-bold text-[#1B4B7F]">${totalMonthlyFee.toLocaleString()}</span>
                  </div>
                  <div className="text-sm text-gray-500">Total Revenue Share: {totalRevShare}%</div>
                </div>
                <div className="bg-[#0D9488]/10 rounded-xl p-4">
                  <div className="flex items-start gap-2">
                    <i className="ri-information-line text-[#0D9488] text-lg mt-0.5"></i>
                    <p className="text-xs text-gray-600">Plus one-time $2,500 onboarding fee. Actual fees may vary based on practice specifics and collections.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <Link to="/#contact" className="inline-flex items-center bg-[#1B4B7F] text-white px-10 py-4 rounded-full text-sm font-semibold hover:bg-[#153a63] transition-all gap-2 whitespace-nowrap cursor-pointer">
                Request Custom Quote
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Transparency Note */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-gradient-to-br from-[#F0F7FF] to-white rounded-3xl p-12 text-center">
            <div className="w-16 h-16 bg-[#1B4B7F] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Your Clinical Independence is Protected</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              All fees strictly cover non-clinical administrative management services. Clinical decisions, patient care protocols, and medical judgment remain 100% under the control of licensed healthcare providers. We handle the business — you handle the medicine.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              {['No hidden fees', 'Transparent billing', 'Clinical autonomy guaranteed'].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-check-line text-[#0D9488] text-xl"></i>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gradient-to-br from-[#1B4B7F] to-[#0D9488]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">Ready to Transform Your Practice?</h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto">
            Schedule a free consultation to discuss your practice needs and get a customized quote.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/#contact" className="bg-white text-[#1B4B7F] px-10 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
              Request Custom Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link to="/partnership" className="bg-[#059669] text-white px-10 py-4 rounded-full text-base font-semibold hover:bg-[#047857] transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <i className="ri-vip-crown-line"></i>
              Explore Partnership Instead
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] relative overflow-hidden">
        <div className="absolute bottom-0 left-0 right-0 text-[#1A2942] text-[180px] font-bold opacity-50 leading-none select-none pointer-events-none">
          MEDXMSO
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-12">
            <div>
              <div className="text-white text-4xl font-bold mb-3">MedxMSO</div>
              <p className="text-gray-400 text-sm mb-16">Healthcare Management Excellence</p>
              <div className="text-white text-lg leading-relaxed">
                <p>Empowering providers</p>
                <p className="text-gray-400">since 2015</p>
              </div>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Our Services</h4>
              <ul className="space-y-4">
                <li><Link to="/services" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Services</Link></li>
                <li><Link to="/mso-pricing" className="text-[#93C5FD] text-sm hover:text-white transition-colors cursor-pointer">Vendor Pricing</Link></li>
                <li><Link to="/partnership" className="text-[#6EE7B7] text-sm hover:text-white transition-colors cursor-pointer">Partnership Model</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Pages</h4>
              <ul className="space-y-4">
                <li><Link to="/" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/pricing" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Pricing Overview</Link></li>
                <li><Link to="/why-mso" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Why MSO?</Link></li>
                <li><Link to="/#contact" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white text-lg font-bold mb-6">Connect</h4>
              <ul className="space-y-4">
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-linkedin-line text-xl"></i>LinkedIn</a></li>
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-twitter-x-line text-xl"></i>Twitter</a></li>
                <li><a href="#" className="flex items-center gap-3 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer"><i className="ri-facebook-line text-xl"></i>Facebook</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2024 MedxMSO. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-500 text-sm hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
